import { Box, Flex, StyleSystemProps, TextV2, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledHeaderContainer = styled(Box)``;

export const StyledHeader = styled(TextV2)``;

const headerBorder: StyleSystemProps = {
  paddingBottom: 4,
  borderBottom: `1px solid`,
  borderColor: 'mono3'
};

const headerContainerStyles = (isScrolled: boolean, isMobile: boolean, carouselHeight: number): StyleSystemProps => ({
  position: 'sticky',
  width: '100%',
  top: isMobile ? -(carouselHeight + 40) : -(carouselHeight + 120),
  backgroundColor: 'white',
  marginX: { _: 6, sm2: 0 },
  ...((isScrolled && headerBorder) || {})
});

const headerStyles: StyleSystemProps = {
  paddingBottom: { _: 5, sm2: 8 },
  marginBottom: { _: 9, sm2: 0 },
  textAlign: 'center',
  fontWeight: 300
};

export const StyledBrandGroupContainer = styled(Flex)``;
const brandGroupContainerStyles: StyleSystemProps = {
  width: '100%',
  flexDirection: 'column',
  paddingTop: { _: 6, sm2: pxToRem(60) },
  paddingBottom: pxToRem(60),
  rowGap: { _: 6, sm2: pxToRem(60) }
};

export const StyledBreadcrumbWrapper = styled(Box)``;
const breadcrumbsWrapperStyles = (isMobile: boolean): StyleSystemProps => ({
  paddingBottom: { _: 4, md: 0 },
  paddingTop: { _: 5, sm2: 10 },
  width: '100%',
  ...(isMobile && {
    backgroundColor: 'white',
    position: 'sticky',
    top: 0,
    height: pxToRem(56),
    paddingLeft: 4
  })
});

export const styles = {
  brandGroupContainer: brandGroupContainerStyles,
  headerContainer: headerContainerStyles,
  header: headerStyles,
  breadcrumbsWrapper: breadcrumbsWrapperStyles
};
